var React = require('react');

function CheckIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"}));
}

CheckIcon.defaultProps = {"fill":"none","viewBox":"0 0 24 24","width":"24","height":"24","strokeWidth":"1","stroke":"currentColor"};

module.exports = CheckIcon;

CheckIcon.default = CheckIcon;
